import React from "react";
import { Box } from "@mui/material";

import { TabHeading, DescriptionProductImage } from "./components";
import useResponsive from "@/hooks/useResponsive";
import { descriptionStyles } from "./styles";

interface IProps {
  description: string;
  imageUrl: string;
  title: string;
}

const DescriptionTab: React.FC<IProps> = ({ description, imageUrl, title }) => {
  const isMobile = useResponsive("down", "md");

  return (
    <>
      <Box display={{ xs: "block", md: "flex" }} gap={{ xs: 3, lg: 6, xl: 10 }}>
        <Box mb={{ xs: 5, md: 0 }}>
          <TabHeading heading="Explore" />
          {!isMobile && (
            <Box
              sx={descriptionStyles}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </Box>
        <DescriptionProductImage title={title} imageUrl={imageUrl} />
      </Box>
      {isMobile && (
        <Box
          sx={descriptionStyles}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </>
  );
};

export default DescriptionTab;
